export default __webpack_public_path__ + "8ea0c32c3f6cbfe0d930662b69759541.svg";